import { z } from 'zod';
/* -------------------------------------------------------------------------- */
/* Guardian privacy settings — Parent steps 3, 11, 27                         */
/*                                                                            */
/* Stored as JSON on `parents.privacy_settings`. An absent row means the       */
/* defaults below, so a guardian who has never opened the screen gets the      */
/* safe answer rather than an empty one.                                      */
/*                                                                            */
/* Only settings this codebase actually enforces live here. A toggle that      */
/* changes nothing is worse than a missing one: it tells a parent their teen   */
/* is protected in a way they are not.                                        */
/* -------------------------------------------------------------------------- */
/**
 * How much of a ward's job conversations this guardian sees. [Parent step 11]
 *
 * There is no "none". A minor's thread always has their guardian in the room —
 * that is the platform's promise to the parent and its warning to the adult on
 * the other side. What a guardian may choose is how closely to read, not
 * whether oversight exists.
 */
export const messageVisibilitySchema = z.enum([
    /** Message bodies, as the teen sees them. */
    'FULL',
    /** Who is talking, when, and how many messages — no content. */
    'METADATA',
]);
export const privacySettingsSchema = z.object({
    messageVisibility: messageVisibilitySchema,
    /**
     * Whether another parent can find this account by email address to send a
     * connection request. Off makes the account unfindable, and the lookup
     * answers exactly as it does for an address with no account at all — a
     * different answer would leak the very thing this turns off.
     * [Parent steps 25-26]
     */
    discoverableByParents: z.boolean(),
    /**
     * Whether connected parents see this guardian's city and state.
     * [Parent step 27]
     */
    showLocationToConnections: z.boolean(),
});
/**
 * Full oversight, findable, location shown.
 *
 * Defaults lean towards the guardian seeing more rather than less: a parent who
 * has not chosen yet should not discover later that they were being shown less
 * about their own child than they assumed.
 */
export const DEFAULT_PRIVACY_SETTINGS = {
    messageVisibility: 'FULL',
    discoverableByParents: true,
    showLocationToConnections: true,
};
export const updatePrivacySettingsInputSchema = privacySettingsSchema.partial();
//# sourceMappingURL=privacy.js.map